<template>
    <div>
        <div v-if="warning" class="d-flex warning mb-3"><base-icon name="error_outline" class="icon" size="md" /><div class="warning_text"><slot name="warning" /></div></div>
        <div class="d-flex justify-content-between mb-3">
            <span>Заполненность характеристик{{ stats.length > 1 ? '' : 'и' }}:</span>
            <span>Общее количество {{ essense }}: {{ get_count(total).count }}</span>
        </div>
        <div>
            <div v-for="stat in stats" :key="stat[0]" class="stat_line mb-3">
                <span v-if="stats.length > 1" class="stat_line_title">{{ stat[0] }}</span>
                <b-progress :max="total" style="flex: 1;">
                    <b-progress-bar class="bad_count" :value="bad_count(stat).count">
                        <span>{{ bad_count(stat).str }}</span>
                    </b-progress-bar>
                    <b-progress-bar class="good_count" :value="good_count(stat).count">
                        <span>{{ good_count(stat).str }}</span>
                    </b-progress-bar>
                </b-progress>
            </div>
        </div>
        <div class="d-flex pb-3" style="gap: 2.5rem;">
            <div class="d-flex align-items-center"><div class="legend bad"></div><span>{{ bad_stat_legend }}</span></div>
            <div class="d-flex align-items-center"><div class="legend good"></div><span>{{ good_stat_legend }}</span></div>
        </div>
    </div>
</template>

<script>
export default {
    props:
    {
        stats : Array,
        total : Number,
        warning : { type : Boolean, default : () => false },
        essense : { type : String, default : () => "объектов оценки" },
        good_stat_legend : { type : String, default : () => "Характеристика заполнена" },
        bad_stat_legend : { type : String, default : () => "Характеристика не заполнена" },
    },

    methods :
    {
        bad_count(stat)
        {
            return this.get_count(this.total - stat[1])
        },

        good_count(stat)
        {
            return this.get_count(stat[1])
        },

        get_count(count)
        {
            const _count = count < 0 || this.total === 0 ? 0 : count
            return {
                count : _count,
                str : `${ _count } (${
                    this.total === 0 || _count === 0
                    ? 0
                    : Math.round((_count / this.total) * 100)
                }%)`
            }
        } 
    }
}
</script>

<style scoped>
.warning
{
    font-size: .875rem;
    border: 1px solid #FF7900;
    border-radius: .5rem;
    padding: .75rem;
    gap: .5rem;
}
.warning_text
{
    flex: 1;
}
.warning .icon
{
    color: #FF7900;
}
.stat_line
{
    display: flex;
}
.stat_line_title
{
    width: 260px;
}
.progress
{
    height: fit-content;
    position: relative;
}
.progress-bar
{
    height: 1.5rem;
}
.progress-bar span
{
    position: absolute;
}
.progress-bar.bad_count, .legend.bad
{
    background-color: var(--bft-blue-200);
}
.progress-bar.good_count span
{
    color: white;
    right: 8px;
}
.progress-bar.bad_count span
{
    color: var(--bft-neutral-900);
    margin-inline: 8px auto;
}
.legend
{
    width: .5rem;
    height: 1rem;
    border-radius: 53px;
    margin-right: 1.5rem;
}
.progress-bar.good_count, .legend.good
{
    background-color: var(--bft-blue-500);
}
</style>